module.exports = __webpack_public_path__ + "static/media/PRISM_6623.395f7108.jpg";